import _eventbus from '@mc/mc-utils/js/event_bus/event_bus'

export const eventbus = _eventbus
